import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { NEW_DASHBOARD_URL, CASE_DATA_COLLECT_URL } from 'src/constants/constants.js';
import RightPanelContainer from 'src/new-ui/features/CaseDataCollect/Container/RightPanelContainer';
import NewDashboardContainer from 'src/new-ui/features/NewDashboard/containers/NewDashboardContainer';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

export const mainDashboardRoute = (
  <Switch>
    <Route path={NEW_DASHBOARD_URL} render={props => <NewDashboardContainer {...props} />} />
    <Route path={CASE_DATA_COLLECT_URL} render={props => <RightPanelContainer {...props} />} />
  </Switch>
);
export const newDashboardRoutes = fnShowNewDashboard() && mainDashboardRoute;
